import React from 'react'
import { HeroOuter, StyledBreadcrumbs } from './style'

// Components
import { ModuleNames } from '../../../../constants/componentNames.constants'
import GlobalContainer from '../../../global/globalContainer'
import Typography from '../../../global/typography'

// Helpers
import ImgUtil from '../../../../utils/img.utils'
import { getMicrocopyWithoutNumber } from '../../../../utils/microcopy.utils'
import formatInlineCode from '../../../../utils/shortTextFormatting'
import WrapperImage from '../../../global/wrapperImage'

const CustomerStoryHero = (props: any) => {
  if (props) {
    const setMetaFields = () => {
      let customerLogoSrc = '',
        customerLogoAlt = ''
      const { microcopy, metaInformation } = props
      const eyebrows: any =
        metaInformation && Array.isArray(metaInformation)
          ? metaInformation.map((topic: any, i: number) => {
              let microcopyType,
                eyebrowText = ''
              let eyebrowValue = topic.title
              const topicType = topic.__typename

              if (topicType === ModuleNames.TOPIC_CUSTOMER_DETAILS) {
                microcopyType = 'client'
                eyebrowValue = topic.customerName
                if (topic.colorLogo) {
                  if (topic.colorLogo.altText) {
                    customerLogoAlt = topic.colorLogo.altText
                  } else {
                    customerLogoAlt = 'UiPath Customer Logo'
                  }
                  if (
                    topic.colorLogo.image &&
                    topic.colorLogo.image.file &&
                    topic.colorLogo.image.file.url
                  ) {
                    customerLogoSrc = topic.colorLogo.image.file.url
                  }
                }
              }
              if (topicType === ModuleNames.TOPIC_REGION) microcopyType = 'region'

              if (topicType === ModuleNames.TOPIC_INDUSTRY) microcopyType = 'industry'

              if (microcopyType) {
                eyebrowText = getMicrocopyWithoutNumber(microcopy, microcopyType, 'eyebrowText')
              }
              return (
                <Typography
                  type="labelAlt"
                  className="Hero__Text-Meta-Item"
                  key={`${topicType}--${i}`}>
                  {eyebrowText && eyebrowText[0] && eyebrowText[0].value && (
                    <span className="Hero__Eyebrow-Grey">{eyebrowText[0].value}</span>
                  )}
                  {eyebrowValue}
                </Typography>
              )
            })
          : null
      return { eyebrows, customerLogoSrc, customerLogoAlt }
    }

    const metaFields: {
      eyebrows: any
      customerLogoSrc: any
      customerLogoAlt: any
    } = setMetaFields()

    const imageSrc = props && props.image && props.image.imageSrc ? props.image.imageSrc : ''
    const imageAlt = props && props.image && props.image.alt ? props.image.alt : ''

    return (
      <HeroOuter data-cy="CustomerStoryHero">
        <GlobalContainer className="Hero__Container">
          <div className="Hero__Top-Items">
            {props.slug && props.pageTitle && (
              <StyledBreadcrumbs
                theme="light"
                currentPathname={`/${props.slug}`}
                pageName={props.pageTitle}
                breadcrumb={props.breadcrumb}
              />
            )}
            <div className="Hero__Logo">
              {metaFields && metaFields.customerLogoSrc && (
                <WrapperImage
                  src={ImgUtil.getResizedImageUrl(metaFields.customerLogoSrc, `width=450`)}
                  alt={metaFields.customerLogoAlt}
                  className="Hero__Logo-File"
                  width={280}
                  height={140}
                  threshold={650}
                />
              )}
            </div>
            <div className="Hero__Text">
              <div className="Hero__Text-Meta">
                {metaFields && metaFields.eyebrows ? metaFields.eyebrows : ''}
              </div>
              {props.h1Title && (
                <Typography className="Hero__Text-H1" type="header1">
                  {formatInlineCode(props.h1Title)}
                </Typography>
              )}
            </div>
          </div>
          <div className="Hero__Main-Img-Grid-BG">
            <div className="Hero__Main-Img-Grid-BG-Img"></div>
            <div className="Hero__Main-Img">
              {imageSrc && (
                <WrapperImage
                  src={ImgUtil.getResizedImageUrl(imageSrc, `width=1020`)}
                  alt={imageAlt}
                  className="Hero__Main-Img-File"
                  width={588}
                  height={330}
                  threshold={650}
                />
              )}
            </div>
          </div>
        </GlobalContainer>
      </HeroOuter>
    )
  }
  return null
}

export default CustomerStoryHero
